import { render, staticRenderFns } from "./ShowsLoader.vue?vue&type=template&id=49621a92&"
import script from "./ShowsLoader.vue?vue&type=script&lang=js&"
export * from "./ShowsLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports